import { getConfigValue } from "../config/runtimeConfig";

const API_BASE =
  getConfigValue("REACT_APP_API_PUBLIC_URL", process.env.REACT_APP_API_PUBLIC_URL) ||
  getConfigValue("REACT_APP_API_PAYMENTS_URL", process.env.REACT_APP_API_PAYMENTS_URL);

const buildUrl = (path) => `${API_BASE}${path}`;

const isJsonResponse = (response) => {
  const contentType = response.headers.get("content-type") || "";
  return contentType.includes("application/json");
};

const parseResponseBody = async (response) => {
  if (isJsonResponse(response)) {
    return response.json();
  }
  return response.text();
};

const request = async (path, options = {}) => {
  if (!API_BASE) {
    throw new Error("REACT_APP_API_PUBLIC_URL (or REACT_APP_API_PAYMENTS_URL) is not set.");
  }
  const timeoutMs = Number(options.timeoutMs) > 0 ? Number(options.timeoutMs) : 30000;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    signal: controller.signal,
    ...options,
  };
  delete config.timeoutMs;

  let response;
  let data;
  try {
    response = await fetch(buildUrl(path), config);
    data = await parseResponseBody(response);
  } catch (error) {
    if (error?.name === "AbortError") {
      throw new Error("Request timed out. Please check API availability and try again.");
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }

  if (!response.ok) {
    const message =
      (typeof data === "string" && data.trim()) ||
      data?.message ||
      data?.error ||
      data?.errorMessage ||
      data?.title ||
      data?.detail ||
      data?.details ||
      data?.error?.message ||
      response.statusText ||
      "Request failed.";
    let details = "";
    if (typeof data === "string") {
      details = data;
    } else if (data && typeof data === "object") {
      details = JSON.stringify(data, null, 2);
    }
    if (!details && response.statusText) {
      details = response.statusText;
    }
    const error = new Error(message);
    if (details) {
      error.details = details;
    }
    throw error;
  }

  return data;
};

export const getPublicSubscriptionPlans = () => request("/public/subscriptions/plans");

